import React, { useState } from 'react'
import { signInWithEmailAndPassword, signOut, onAuthStateChanged, sendPasswordResetEmail, createUserWithEmailAndPassword } from "firebase/auth"
import { auth } from './base'
import useFirebase from './useFirebase'

const useAuthFirebase = () => {
    const [user, setUser] = useState({})
    const [count, setCount] = useState(1)
    const { writeData, updateData } = useFirebase() 

    const _signIn = (email, password, token, clients, keyUid) => {
        console.log('signin use authentification ', email, password) 
        signInWithEmailAndPassword(auth, email, password)
            .then((useCredential) => {
                const user = useCredential.user
                _updateToken(email,token,clients,keyUid)
                // user.uid === keyUid && navigate('/homeServeur')
            })
            .catch((error) => {
                console.log("error useauthentification signin ",error)
                const errorCode = error.errorCode
                const errorMessage = error.message
            })
    }

    const _signUp = (name, surname, email, password, key, token,phone) => {
        console.log('signUp use authentification ', name, surname, email, password, key, phone)
        createUserWithEmailAndPassword(auth, email, password)
            .then((useCredential) => {
                const user = useCredential.user
                // enregistrer ici le document dans firebase
                let nameClient = name.toUpperCase()
                let surnameClient = surname.charAt(0).toUpperCase() + surname.slice(1)
                const data = {name:nameClient, surname:surnameClient, email:email, phone:phone? phone : '' ,uid:user.uid, token:token}
                console.log('useAuthFirebase Create Account ',surname, name, email, password, key, token)
                writeData('entreprises/'+key+'/clients',data)
            })
            .catch((error) => {
                console.log("error useauthentification signUp ",error)
                const errorCode = error.errorCode
                const errorMessage = error.message
            })
    }

    const _signOut = () => {
        console.log('useAuth _signOut method')
        signOut(auth).then(() => {
            console.log('useAuth _signOut OK ')
            setCount(count+1)
            _onAuth()
        }).catch((error) => {
            console.log(error)
        })
    }

    const _onAuth = () => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                setUser(user)
            } else {
                setUser({})
            }
        })
    }

    const _forgotPassword = (email) => {
        if (!email) {alert('Veuillez renseigner un email valide')}
        sendPasswordResetEmail(auth, email)
            .then(() => {
                alert('Un lien à été envoyer sur votre boite de messagerie')
            })
            .catch((error) => {
                const errorCode = error.code
                const errorMessage = error.message
            })
    }

    // UPDATE TOKEN 
    const _updateToken = (email, token, clients, key) => {
        const data = {token:token}
        clients.filter(c => c.email === email && c.token !== token).map(c => (
            updateData('entreprises/'+key+'/clients/'+c.id,data)
        )) 
    }

    return { user, _onAuth, _signIn, _signOut, _forgotPassword, _signUp }
}

export default useAuthFirebase

